import { getCurrentUser } from './auth';
import { fetchAdminPermissions } from '../api/adminPermissions';

export const DEFAULT_MANAGER_PERMISSIONS = {
  'user.read': true,
  'user.email.update': true,
  'user.password.reset': true,
  'user.delete': false,
  'device.read': true,
  'coupon.read': true,
  'coupon.create': true,
  'coupon.bulk.create': false,
  'coupon.register': true,
  'credit.read': true,
  'credit.claim': false,
  'mail.read': true,
  'mail.resend': true,
  'admin.read': false,
  'admin.create': false,
  'admin.delete': false,
  'settings.manage': false,
};

let permissionCache = {};

function normalizePermissionMap(permissions = []) {
  if (!Array.isArray(permissions)) return {};

  return permissions.reduce((acc, permission) => {
    if (permission?.permissionKey) {
      acc[permission.permissionKey] = permission.enabled === true;
    }
    return acc;
  }, {});
}

export function setAdminPermissionCache(userUuid, permissions) {
  if (!userUuid) return;

  permissionCache = {
    ...permissionCache,
    [userUuid]: Array.isArray(permissions)
      ? normalizePermissionMap(permissions)
      : permissions,
  };
}

export function getCachedAdminPermissions(userUuid) {
  return permissionCache[userUuid] || {};
}

export function clearAdminPermissionCache() {
  permissionCache = {};
}

export async function loadCurrentUserPermissions() {
  const currentUser = getCurrentUser();

  if (!currentUser?.uuid || currentUser.role === 'Admin') {
    return {};
  }

  const permissions = await fetchAdminPermissions(currentUser.uuid);
  setAdminPermissionCache(currentUser.uuid, permissions);
  return getCachedAdminPermissions(currentUser.uuid);
}

export function can(permissionKey) {
  const currentUser = getCurrentUser();

  if (currentUser?.role === 'Admin') return true;
  if (!currentUser?.uuid) return false;

  const userPermissions = getCachedAdminPermissions(currentUser.uuid);

  if (Object.prototype.hasOwnProperty.call(userPermissions, permissionKey)) {
    return userPermissions[permissionKey] === true;
  }

  return DEFAULT_MANAGER_PERMISSIONS[permissionKey] === true;
}
